import Executive from '../../framework/rmi-util'
import { startCancelOrdersJob, getJobStatus, getJobsByContainer, getCancelOrdersJobs } from './BackgroundJobTechnical'
import { register } from '../../framework/rmi-server-util'
import { BackgroundJob } from '../system/system.entities'
import { context } from '../../framework/context-util'
import { StartCancelOrdersJobRequest, StartJobResponse, JobStatusResponse } from './types'

export default class BackgroundJobExecutive extends Executive {

	initServer() {
	}

	// @CheckApiKey()
	async startCancelOrdersJob(request: StartCancelOrdersJobRequest): Promise<StartJobResponse> {
		const createdBy = context.userEmail || 'api-user'
		return await startCancelOrdersJob(request, createdBy)
	}

	async getJobStatus(jobId: string): Promise<JobStatusResponse> {
		return await getJobStatus(jobId)
	}

	async getJobsByContainer(containerKey: string): Promise<BackgroundJob[]> {
		return await getJobsByContainer(containerKey)
	}

	async getCancelOrdersJobs(productId: string, date: string, timeSlot: string): Promise<BackgroundJob[]> {
		return await getCancelOrdersJobs(productId, date, timeSlot)
	}
}

register(BackgroundJobExecutive)
